import Header from '../components/header';
import '../css/index.scss';

const header = new Header()

new (class Index {
    constructor() {
        this.render()
    }

    render() {

    }
})()